import * as React from "react";
import type { SVGProps } from "react";
const SvgTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <circle cx={60} cy={60} r={60} fill="#fff" />
    <path
      fill="#00F2EA"
      d="M51.686 51.686v-3.139a24 24 0 0 0-3.287-.24C34.946 48.308 24 59.256 24 72.709c0 8.253 4.124 15.558 10.416 19.976a24.3 24.3 0 0 1-6.552-16.612c0-13.262 10.635-24.077 23.822-24.386"
    />
    <path
      fill="#00F2EA"
      d="M52.263 87.214c6.002 0 10.898-4.775 11.122-10.726l.02-53.124h9.706A18.4 18.4 0 0 1 72.798 20H59.542l-.022 53.126c-.221 5.95-5.12 10.723-11.12 10.723a11.06 11.06 0 0 1-5.17-1.28 11.13 11.13 0 0 0 9.033 4.645M91.24 41.397v-2.953a18.33 18.33 0 0 1-10.043-2.985 18.45 18.45 0 0 0 10.044 5.938"
    />
    <path
      fill="#FF004F"
      d="M81.197 35.456a18.36 18.36 0 0 1-4.536-12.09H73.11a18.48 18.48 0 0 0 8.087 12.09M48.399 61.564c-6.151.007-11.136 4.991-11.143 11.143a11.15 11.15 0 0 0 5.971 9.863 11.07 11.07 0 0 1-2.108-6.498c.007-6.151 4.991-11.138 11.143-11.145 1.148 0 2.249.19 3.288.516V51.91a24 24 0 0 0-3.288-.24c-.193 0-.383.011-.575.015V62.08a11 11 0 0 0-3.288-.516"
    />
    <path
      fill="#FF004F"
      d="M91.24 41.397v10.302a31.53 31.53 0 0 1-18.443-5.93v26.938c0 13.454-10.944 24.4-24.397 24.4-5.2 0-10.02-1.641-13.983-4.424a24.33 24.33 0 0 0 17.845 7.787c13.454 0 24.399-10.945 24.399-24.397v-26.94a31.52 31.52 0 0 0 18.442 5.931V41.805a18.4 18.4 0 0 1-3.865-.411"
    />
    <path
      fill="#000"
      d="M72.796 72.707v-26.94a31.5 31.5 0 0 0 18.442 5.931V41.397a18.45 18.45 0 0 1-10.042-5.94 18.48 18.48 0 0 1-8.087-12.09h-9.705l-.02 53.124c-.223 5.949-5.12 10.724-11.123 10.724a11.13 11.13 0 0 1-9.032-4.644 11.15 11.15 0 0 1-5.973-9.863c.007-6.152 4.992-11.136 11.143-11.143 1.146 0 2.247.187 3.287.515V51.686c-13.187.31-23.822 11.124-23.822 24.386 0 6.413 2.492 12.252 6.552 16.612A24.25 24.25 0 0 0 48.4 97.106c13.454 0 24.397-10.946 24.397-24.4"
    />
  </svg>
);
export default SvgTiktok;
